function clearResizePosition(cube: CubeNode): void {
    cube.jView.find('.J_ShelvesFreezer').css({
        top: '',
        left: ''
    });
}

export {
    clearResizePosition
};
